export default "__VITE_ASSET__CrqjUdW2__"